/**
 * src/sync/baseUrl.js — single source of truth for the backend base URL.
 *
 * Resolves VITE_API_BASE_URL at build time (Vue CLI webpack DefinePlugin) with
 * a localhost fallback for dev. Use this from every sync/adminApi/signalr
 * call site so the dev/staging/prod URL story stays consistent — prior to
 * extraction there were three independent copies of this function (api.js,
 * adminApi.js, signalrClient.js) and the literal-access gotcha had to be
 * re-learned in each.
 *
 * Critical: read `process.env.VITE_API_BASE_URL` via LITERAL property access
 * — Vue CLI's DefinePlugin only substitutes literal `process.env.X`. Subscript
 * access (`process.env[key]`) silently falls back to DEFAULT_BASE_URL in prod,
 * which is the exact mixed-content trap we hit in May 2026 (commit a4736ba).
 * vue.config.js wires the env value into the bundle via DefinePlugin.
 */

const DEFAULT_BASE_URL = 'http://127.0.0.1:5050';

export function getApiBaseUrl() {
  return process.env.VITE_API_BASE_URL || DEFAULT_BASE_URL;
}
